(function () {

  /* -------------------------
    Utilities
  ------------------------- */
  function buildSrcset(url) {
    if (!url) return '';
    var join = url.indexOf('?') === -1 ? '?' : '&';
    return [480, 800, 1200]
      .map(function (w) { return url + join + 'width=' + w + ' ' + w + 'w'; })
      .join(', ');
  }

  function applyResponsiveAttrs(el, src, isDesktop) {
    if (!el || !src) return;
    el.srcset = buildSrcset(src);
    el.sizes = isDesktop ? '(min-width: 980px) 50vw, 100vw' : '100vw';
  }

  function withWidth(url, w) {
    if (!url) return url;
    var join = url.indexOf('?') === -1 ? '?' : '&';
    return url + join + 'width=' + w;
  }

  function isDesktop() {
    return window.matchMedia('(min-width: 980px)').matches;
  }

  /* -------------------------
    Premium single mode detection
    If all items resolve to same desktop src -> disable swapping
  ------------------------- */
  function enablePremiumDisableSwappingIfNeeded(root, items) {
  // Respect merchant setting: if disabled swapping explicitly, keep it
  if (root.getAttribute('data-disable-swapping') === 'true') return true;

  if (!items || !items.length) return false;

  var desktopSrcs = items
    .map(function (d) { return (d.getAttribute('data-src-desktop') || '').trim(); })
    .filter(Boolean);

  var mobileSrcs = items
    .map(function (d) { return (d.getAttribute('data-src-mobile') || '').trim(); })
    .filter(Boolean);

  // If nothing exists, do nothing
  if (!desktopSrcs.length && !mobileSrcs.length) return false;

  var uniqueDesktop = Array.from(new Set(desktopSrcs));
  var uniqueMobile  = Array.from(new Set(mobileSrcs));

  // Only auto-disable if BOTH desktop and mobile are single unique values
  if (uniqueDesktop.length <= 1 && uniqueMobile.length <= 1) {
    root.setAttribute('data-disable-swapping', 'true');
    root.classList.add('ais-single-image-mode');
    return true;
  }

  root.classList.remove('ais-single-image-mode');
  return false;
}

  /* -------------------------
    Preload (only when swapping enabled)
  ------------------------- */
  function createPreloadLink(url, desktop) {
    if (!url) return;
    try {
      var link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.imagesrcset = buildSrcset(url);
      link.imagesizes = desktop ? '(min-width: 980px) 50vw, 100vw' : '100vw';
      document.head.appendChild(link);
    } catch (e) { }
  }

  function eagerPreload(url, desktop, highPriority) {
    if (!url) return;
    var img = new Image();
    img.decoding = 'async';
    try { img.fetchPriority = highPriority ? 'high' : 'low'; } catch (e) { }
    applyResponsiveAttrs(img, url, desktop);
    img.src = url;
  }

  function preloadImages(root, disableSwapping) {
    if (disableSwapping) return;

    var desktop = isDesktop();
    var items = Array.prototype.slice.call(root.querySelectorAll('details.ais-item'));

    items.forEach(function (d, idx) {
      var src = desktop ? d.getAttribute('data-src-desktop') : d.getAttribute('data-src-mobile');
      if (!src) src = desktop ? d.getAttribute('data-src-mobile') : d.getAttribute('data-src-desktop');
      if (!src) return;

      var warmSrc = desktop ? src : withWidth(src, 480);
      if (idx < 2) createPreloadLink(src, desktop);
      eagerPreload(warmSrc, desktop, false);
    });
  }

  /* -------------------------
    Accordion slide
  ------------------------- */
  function slideOpen(detailsEl, panel, duration) {
    var prefersReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduce) {
      detailsEl.setAttribute('open', 'open');
      return Promise.resolve();
    }

    return new Promise(function (resolve) {
      detailsEl.setAttribute('open', 'open');

      panel.style.overflow = 'hidden';
      panel.style.height = '0px';

      var target = panel.scrollHeight;
      var anim = panel.animate([{ height: '0px' }, { height: target + 'px' }], {
        duration: duration,
        easing: 'ease'
      });

      panel.style.height = target + 'px';

      anim.addEventListener('finish', function () {
        panel.style.height = '';
        panel.style.overflow = '';
        resolve();
      }, { once: true });
    });
  }

  function slideClose(detailsEl, panel, duration) {
    var prefersReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduce) {
      detailsEl.removeAttribute('open');
      return Promise.resolve();
    }

    return new Promise(function (resolve) {
      var start = panel.scrollHeight;
      panel.style.overflow = 'hidden';
      panel.style.height = start + 'px';

      var anim = panel.animate([{ height: start + 'px' }, { height: '0px' }], {
        duration: duration,
        easing: 'ease'
      });

      anim.addEventListener('finish', function () {
        detailsEl.removeAttribute('open');
        panel.style.height = '';
        panel.style.overflow = '';
        resolve();
      }, { once: true });
    });
  }

  /* -------------------------
    Smart sticky (your existing behavior)
  ------------------------- */
  function updateSmartSticky(root) {
    if (!window.matchMedia('(min-width: 980px)').matches) {
      root.classList.remove('ais-sticky-both');
      return;
    }

    var media = root.querySelector('.ais-media');
    var content = root.querySelector('.ais-content');
    if (!media || !content) return;

    var mediaH = media.getBoundingClientRect().height;
    var contentH = content.getBoundingClientRect().height;

    if (contentH < mediaH) root.classList.add('ais-sticky-both');
    else root.classList.remove('ais-sticky-both');
  }

  function makeResizeObserver(root) {
    if (!('ResizeObserver' in window)) return;

    var content = root.querySelector('.ais-content');
    if (!content) return;

    var raf;
    var ro = new ResizeObserver(function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        updateSmartSticky(root);
      });
    });

    ro.observe(content);
  }

  /* -------------------------
    Swap Desktop + Mobile (only when swapping enabled)
  ------------------------- */
  function swapDesktop(mediaFigure, img, newSrc, newAlt, prefersReduce) {
    if (!img || !mediaFigure || !newSrc) return;

    if (prefersReduce) {
      img.src = newSrc;
      img.alt = newAlt || '';
      applyResponsiveAttrs(img, newSrc, true);
      return;
    }

    mediaFigure.style.overflow = 'hidden';

    var oldLayer = img.cloneNode(true);
    oldLayer.removeAttribute('class');
    Object.assign(oldLayer.style, {
      position: 'absolute', inset: '0',
      width: '100%', height: '100%',
      objectFit: 'cover',
      animation: 'ia-fade-zoom-out 360ms ease both'
    });

    var newLayer = new Image();
    newLayer.src = newSrc;
    newLayer.alt = newAlt || '';
    applyResponsiveAttrs(newLayer, newSrc, true);
    Object.assign(newLayer.style, {
      position: 'absolute', inset: '0',
      width: '100%', height: '100%',
      objectFit: 'cover',
      animation: 'ia-fade-zoom-in 380ms ease both'
    });
    newLayer.loading = 'lazy';
    newLayer.decoding = 'async';

    mediaFigure.appendChild(oldLayer);
    mediaFigure.appendChild(newLayer);

    newLayer.addEventListener('animationend', function () {
      img.src = newSrc;
      img.alt = newAlt || '';
      applyResponsiveAttrs(img, newSrc, true);
      oldLayer.remove();
      newLayer.remove();
    }, { once: true });
  }

  function swapMobile(panelEl, newSrc, newAlt, prefersReduce) {
    var mobileImg = panelEl.querySelector('.ais-img-mobile');
    if (!mobileImg || !newSrc) return;

    mobileImg.classList.add('is-blur');

    // Set final src immediately to avoid 2-3s blank on mobile
    mobileImg.loading = 'eager';
    try { mobileImg.fetchPriority = 'high'; } catch (e) {}
    mobileImg.decoding = 'async';
    mobileImg.src = withWidth(newSrc, 480);
    applyResponsiveAttrs(mobileImg, newSrc, false);

    eagerPreload(withWidth(newSrc, 480), false, true);

    if (prefersReduce) {
      mobileImg.alt = newAlt || '';
      return;
    }

    panelEl.style.position = 'relative';
    panelEl.style.overflow = 'hidden';
    panelEl.style.transform = 'none';

    var oldLayer = mobileImg.cloneNode(true);
    Object.assign(oldLayer.style, {
      position: 'absolute', inset: '0',
      width: '100%', height: 'auto',
      animation: 'ia-fade-zoom-out 320ms ease both'
    });

    var newLayer = new Image();
    newLayer.alt = newAlt || '';
    newLayer.className = mobileImg.className.replace('is-blur', '').trim();
    applyResponsiveAttrs(newLayer, newSrc, false);
    Object.assign(newLayer.style, {
      position: 'absolute', inset: '0',
      width: '100%', height: 'auto',
      animation: 'ia-fade-zoom-in 340ms ease both'
    });
    newLayer.loading = 'eager';
    try { newLayer.fetchPriority = 'high'; } catch (e) { }
    newLayer.decoding = 'async';
    newLayer.src = newSrc;

    panelEl.appendChild(oldLayer);
    panelEl.appendChild(newLayer);

    newLayer.addEventListener('load', function () {
      mobileImg.classList.remove('is-blur');
    });

    newLayer.addEventListener('animationend', function () {
      mobileImg.src = newSrc;
      mobileImg.alt = newAlt || '';
      applyResponsiveAttrs(mobileImg, newSrc, false);
      oldLayer.remove();
      newLayer.remove();
      panelEl.style.overflow = '';
    }, { once: true });
  }

  /* -------------------------
    INIT
  ------------------------- */
  function init(root) {
    var prefersReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var mediaFigure = root.querySelector('.ais-media');
    var img = mediaFigure ? (mediaFigure.querySelector('img.ais-active') || mediaFigure.querySelector('img')) : null;

    var items = Array.prototype.slice.call(root.querySelectorAll('details.ais-item'));

    // Premium auto disable
    enablePremiumDisableSwappingIfNeeded(root, items);

    function disableSwapping() {
      return root.getAttribute('data-disable-swapping') === 'true';
    }

    makeResizeObserver(root);
    updateSmartSticky(root);

    function swap(detailsEl) {
      if (disableSwapping()) return;

      var alt = detailsEl.getAttribute('data-alt') || '';
      var desktop = isDesktop();

      var src = desktop ? detailsEl.getAttribute('data-src-desktop') : detailsEl.getAttribute('data-src-mobile');
      if (!src) src = desktop ? detailsEl.getAttribute('data-src-mobile') : detailsEl.getAttribute('data-src-desktop');
      if (!src) return;

      if (desktop) swapDesktop(mediaFigure, img, src, alt, prefersReduce);
      else {
        var panel = detailsEl.querySelector('.ais-panel');
        if (panel) swapMobile(panel, src, alt, prefersReduce);
      }
    }

    function closeSiblings(openEl) {
      items.forEach(function (d) {
        if (d !== openEl && d.open) {
          var p = d.querySelector('.ais-panel');
          if (p) slideClose(d, p, 260).then(function () {
            updateSmartSticky(root);
          });
        }
      });
    }

    items.forEach(function (d) {
      var summary = d.querySelector('.ais-summary');
      var panel = d.querySelector('.ais-panel');
      if (!summary || !panel) return;

      summary.addEventListener('click', function (e) {
        e.preventDefault();

        var opening = !d.open;

        if (opening) {
          closeSiblings(d);
          slideOpen(d, panel, 300).then(function () {
            swap(d);
            updateSmartSticky(root);
          });
        } else {
          slideClose(d, panel, 280).then(function () {
            updateSmartSticky(root);
          });
        }
      });
    });

    var initiallyOpen = items.find(function (d) { return d.open; }) || items[0];
    if (initiallyOpen) swap(initiallyOpen);
var lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth !== lastWidth) {
        updateSmartSticky(root);
      var openItem = items.find(function (d) { return d.open; }) || items[0];
      if (openItem) swap(openItem);
        lastWidth = window.innerWidth;
      }
      
    });

    // Preload only if swapping enabled
    if ('IntersectionObserver' in window) {
      var once = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (once) return;
          if (entry.isIntersecting || entry.intersectionRatio > 0) {
            once = true;
            preloadImages(root, disableSwapping());
            io.disconnect();
          }
        });
      }, { root: null, rootMargin: '300px 0px', threshold: 0 });

      io.observe(root);
    } else {
      preloadImages(root, disableSwapping());
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ais-root]').forEach(init);
  });

})();